import { routes } from './routes.tsx'
import { createBrowserRouter } from 'react-router-dom'
import {
  dashboard,
  firmManagement,
  idea,
  mailListManagement,
  myAchievements,
  overallRanking,
  rules,
  statistics,
  tickerManagement,
  userManagement,
} from './router-object.tsx'
import { LoginPage } from '../pages/login-page.tsx'
import { RouteGuard } from './router-guard.tsx'
import { IdeyaRoute } from './router.def.ts'
import { Disclaimer } from '../pages/disclaimer/disclaimer.tsx'
import { GlobalDisclaimer } from '../pages/disclaimer/global-disclaimer.tsx'
import { Logout } from '../pages/logout/logout.tsx'
import { Inactive } from '../pages/inactive/inactive.tsx'
import { Root } from '../common/layouts/root.tsx'
import { isAuth0, isInternalWebsite, isIppon } from '../utils/helpers.ts'
import { Auth0LoginPage } from '../pages/auth0-login-page.tsx'
import { Auth0Root } from '../common/layouts/auth0-root.tsx'
import { IpponRoot } from '../common/layouts/ippon-root.tsx'
import { RouteError } from './route-error.tsx'

const isAuth0External = isAuth0 && !isInternalWebsite

const getRootElement = () => {
  if (isIppon) return <IpponRoot />
  if (isAuth0External) return <Auth0Root />
  return <Root />
}

const wrapWithRouteGuard = (route: IdeyaRoute) => {
  return {
    ...route,
    element: <RouteGuard route={route}>{route.element}</RouteGuard>,
  }
}

export const remixRouter = createBrowserRouter([
  {
    path: routes.login,
    element:
      isIppon || isAuth0External ? <Auth0LoginPage /> : <LoginPage />,
    errorElement: <RouteError />,
  },
  {
    path: routes.logout,
    element: <Logout />,
    errorElement: <RouteError />,
  },
  {
    path: routes.disclaimer,
    element: <Disclaimer />,
    errorElement: <RouteError />,
  },
  {
    path: routes.globalDisclaimer,
    element: <GlobalDisclaimer />,
    errorElement: <RouteError />,
  },
  {
    path: routes.inactive,
    element: <Inactive />,
    errorElement: <RouteError />,
  },
  {
    path: '/',
    element: getRootElement(),
    errorElement: <RouteError />,
    children: [
      wrapWithRouteGuard(dashboard),
      wrapWithRouteGuard(idea),
      wrapWithRouteGuard(overallRanking),
      wrapWithRouteGuard(myAchievements),
      wrapWithRouteGuard(statistics),
      wrapWithRouteGuard(firmManagement),
      wrapWithRouteGuard(userManagement),
      wrapWithRouteGuard(mailListManagement),
      wrapWithRouteGuard(tickerManagement),
      wrapWithRouteGuard(rules),
    ],
  },
])
